module.exports = __webpack_public_path__ + "img/rang8.15c11539.png";